module.exports = {
	// rest:'http://106.53.173.116:19109',
	rest:'https://2020dance.cn'
	// rest:'http://118.25.176.116:19109'
	// rest: 'https://www.docker-cloud.com'
  }


// WEBPACK FOOTER //
// ./src/config/prod.js